let reloadBlocked = false;
const listeners = new Set<() => void>();

export function getPwaReloadBlocked(): boolean {
  return reloadBlocked;
}

export function setPwaReloadBlocked(blocked: boolean): void {
  if (reloadBlocked === blocked) {
    return;
  }
  reloadBlocked = blocked;
  for (const listener of listeners) {
    listener();
  }
}

export function subscribePwaReloadBlocked(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
